import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentCategory } from 'app/selectors/productSelector';
import { Tooltip, Checkbox } from 'app/seedly-component-library';
import buildConfig from 'app/utils/buildConfig';
import get from 'lodash/get';
import find from 'lodash/find';
import withModal from './withModal';

const ProductFilter = ({ filterId, setFilter, filterCheckList }) => {
  const currentCategory = useSelector(state => getCurrentCategory(state));
  const filters = get(currentCategory, 'filters', null);
  const filterItem = find(filters, { id: filterId });

  if (!filterItem) return null;

  const hintMapJson = get(filterItem, 'extra.hints', '{}');
  const options = get(filterItem, 'options', null);

  if (!options) return null;

  let hintMap;
  try {
    hintMap = JSON.parse(hintMapJson);
  } catch {
    hintMap = {};
  }

  return (
    <div className="flex flex-col gap-4">
      {options.map(option => {
        const hintText = hintMap[option] || null;
        const isChecked = filterCheckList.includes(option);
        return (
          <Checkbox
            key={option}
            name={option}
            onChange={() => {
              if (!isChecked) {
                setFilter([...filterCheckList, option]);
              } else {
                setFilter(
                  filterCheckList.filter(item => {
                    return item !== option;
                  }),
                );
              }
            }}
            checked={isChecked}
          >
            <div className="flex items-center">
              {option}
              {hintText && (
                <Tooltip
                  // style={{ display: 'inline' }}
                  showToolTip
                  placement="right"
                  renderTriggerButton={() => {
                    return (
                      <img
                        alt="question-mark"
                        className="w-[14px] ml-2 self-center"
                        src={`${buildConfig.s3BucketEndpoint}/icon/question-mark.svg`}
                      />
                    );
                  }}
                  renderToolTipBody={() => (
                    <div className="w-[150px] flex-wrap">{hintText}</div>
                  )}
                />
              )}
            </div>
          </Checkbox>
        );
      })}
    </div>
  );
};

export default withModal(ProductFilter);
